import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './standard_error.less'
import { withRouter } from 'react-router'
import { routerShape } from 'react-router/lib/PropTypes'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/common/standard_error')

class StandardError extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    iconType: PropTypes.oneOf(['warning', 'error']),
    showButton: PropTypes.bool,
    onTryAgain: PropTypes.func,
    backButton: PropTypes.bool,
    extraContent: PropTypes.element,
    router: routerShape,
  }

  static defaultProps = { iconType: 'warning' }

  handleButtonClick = () => {
    if (this.props.backButton) {
      this.props.router.goBack()
    } else if (this.props.onTryAgain) {
      this.props.onTryAgain()
    }
  }

  render() {
    const iconClass = (() => {
      switch (this.props.iconType) {
        case 'warning':
          return 'icon-attention-large'
        case 'error':
          return 'icon-critical-large'
        default:
          return ''
      }
    })()
    return (
      <div styleName="standardError">
        <span
          className={`icon icon-large ${iconClass}`}
          styleName="large-icon"
        />
        <div styleName="title">{this.props.title}</div>
        <div styleName="subtitle">{this.props.subtitle}</div>
        {this.props.showButton && (
          <button
            data-pa-click="tryAgain"
            className="vx_btn vx_btn-block"
            onClick={this.handleButtonClick}
          >
            {this.props.backButton ? i18n('back') : i18n('try_again')}
          </button>
        )}
        {this.props.extraContent}
      </div>
    )
  }
}

export default withRouter(cssModules(StandardError, styles))
